module.exports = __webpack_public_path__ + "static/Pluto-21a4b56bc9260e702bd35a0bee9c3674.png";